export const MenuList = [
    //Dashboard
    
    {   
        title:'Dashboard',
        iconStyle: <i className="flaticon-381-home-2"></i>,
        to: '/dashboard',
    },


    // User Management
    {
        title: 'Users',	
        classsChange: 'mm-collapse',
        iconStyle: <i className="flaticon-381-user-7"></i>,
        content: [
            
            {
                title: 'List Users',
                to: '/user-list',					
            },
            {
                title: 'Add User',
                to: '/user-add',					
            }
        ]
    },

    // Organizer Management
    {
        title: 'Organizer',	
        classsChange: 'mm-collapse',
        iconStyle: <i className="flaticon-381-user-2"></i>,
        content: [
            
            {
                title: 'List Organizer',
                to: '/organizer-list',					
            },
            {
                title: 'Add Organizer',
                to: '/organizer-add',					
            }
        ]
    },

    //Organizers Users
    {
        title: 'Org Users',	
        classsChange: 'mm-collapse',
        iconStyle: <i className="flaticon-381-user-7"></i>,
        content: [
    
            {
                title: 'Org Users List',
                to: '/organizers-user-list',					
            }
        ]
    },

    // Events Management
    {
        title: 'Events',	
        classsChange: 'mm-collapse',
        iconStyle: <i className="flaticon-381-calendar-1"></i>,
        content: [
            
            {
                title: 'List Events',
                to: '/events-list',					
            },
            {
                title: 'Add Event',
                to: '/event-add',					
            }
        ]
    },

    // Venues Management
    {
        title: 'Venues',
        classsChange: 'mm-collapse',
        iconStyle: <i className="flaticon-381-location" />,
        content: [
            {
                title: 'Venue List',
                to: '/venue-list',
            },
            {
                title: 'Add Venue',
                to: '/venue-add',
            },
        ]
    },

    // Transaction Pages

    {
        title: 'Transaction',	
        classsChange: 'mm-collapse',
        iconStyle: <i className="flaticon-381-list-1"></i>,
        content: [
            
            // {
            //     title: 'Transaction',
            //     to: '/transaction',					
            // },
            {
                title: 'Primary Market',
                to: '/primary-market-transaction',					
            },
            {
                title: 'Secondary Market',
                to: '/secondary-market-transaction',					
            },
            {
                title: 'Organizers',
                to: '/organizers-transaction',					
            },
            {
                title: 'Withdrawals',
                to: '/withdrawal-transaction',					
            }
        ]
    },

    {
        title:'Resale Market',
        classsChange: 'mm-collapse',
        iconStyle: <i className="flaticon-381-repeat-1"></i>,
        content : [            
            {
                title:'Listed Tickets',
                to: '/listed-tickets',
            },
            {
                title:'Sold Tickets',
                to: '/sold-tickets',
            },
        ]
    }, 

    //Org Ticket
    {   
        title:'Org Tickets',
        iconStyle: <i className="flaticon-381-id-card-3"></i>,
        to: '/org-tickets',
    },

    //CMS Pages
    {   
        title:'CMS Pages',
        iconStyle: <i className="flaticon-381-layer-1"></i>,
        to: '/cms-page-list',
    },

    //Pages
    {
        title:'Settings',
        classsChange: 'mm-collapse',
        iconStyle: <i className="flaticon-381-settings-2"></i>,
        content : [            
            {
                title:'General Settings',
                to: '/general-settings',
            },
            {
                title:'SEM Settings',
                to: '/sem-settings',
            },
            // {
            //     title:'Resell Ticket Settings',
            //     to: '/resell-settings',
            // },
        ]
    },    

    //Posters
    {   
        title:'Poster Setting',
        iconStyle: <i className="fa-solid fa-file-image"></i>,
        to: '/poster',
    },
]